import type { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import type { AuthenticationStepInput } from '../../authentication/types/authentication-step-input';

export interface SessionState {
  token: { jwt: string; exp: number };
  authentication: {
    submittingResponse: boolean;
    steps: AuthenticationStep[];
    answers: AuthenticationStepInput[];
  };
  status: DocumentStatus;
  error: boolean;
  isCorrectPin: boolean;
  sendPinRetryCount: number;
  recipientFirstOpen: boolean;
}

export enum SessionAction {
  LoadToken = 'loadToken',
  LoadTokenSuccess = 'loadTokenSuccess',
  LoadTokenFailed = 'loadTokenFailed',
  SetAuthenticationSteps = 'setAuthenticationSteps',
  SetAuthenticationAnswers = 'setAuthenticationAnswers',
  SubmitAnswer = 'submitAnswer',
  SendSmsCode = 'sendSmsCode',
  SendSmsCodeFailed = 'sendSmsCodeFailed',
  SendSmsCodeThrottleFailed = 'sendSmsCodeThrottleFailed',
  SendSmsCodeLockedFailed = 'sendSmsCodeLockedFailed',
  SubmitSmsAnswer = 'submitSmsAnswer',
  SubmitSmsAnswerFailed = 'submitSmsAnswerFailed',
  SubmitQnaAnswer = 'submitQnaAnswer',
  SubmitQnaAnswerFailed = 'submitQnaAnswerFailed',
  SubmitConsent = 'submitConsent',
  DeclineConsent = 'declineConsent',
  HandleGdprConsent = 'handleGdprConsent',
  HandleTrackingConsent = 'handleTrackingConsent',
  SubmitConsentFailed = 'submitConsentFailed',
  SetStatus = 'setStatus',
  SetPreviewToken = 'setPreviewToken',
  SetRecipientFirstOpen = 'setRecipientFirstOpen',
}

export enum SessionMutation {
  SetToken = 'setToken',
  SetError = 'setError',
  SetStatus = 'setStatus',
  SetAuthenticationSteps = 'setAuthenticationSteps',
  SetAuthenticationAnswers = 'setAuthenticationAnswers',
  VerifySms = 'verifySms',
  SetSubmittingResponse = 'setSubmittingResponse',
  SetSendPinRetryCount = 'setSendPinRetryCount',
  SetRecipientFirstOpen = 'setRecipientFirstOpen',
}

export enum SessionGetter {
  NextAuthStep = 'nextAuthStep',
  ConsentSteps = 'consentSteps',
  DocumentRecalled = 'documentRecalled',
  DocumentRejected = 'documentRejected',
  GDPRDeclined = 'gdprDeclined',
}
